import { connect } from 'react-redux';
import * as actions from './NetWorthReportActions';
import ProjectedBalanceSheetView from './NetWorthReportView';
import {
  hasAccessToLinkAccountsSelector,
  selectPortalName,
  showNetWorthSelector,
} from '../CommonSelectors/CommonAreaSelector';

const mapStateToProps = (state, ownProps) => {
  const subdivision = state.NetWorthReport[ownProps.clientId];

  return {
    clientId: ownProps.clientId,
    is_initialized: subdivision ? subdivision.is_initialized : false,
    CurrentNetWorth: subdivision ? subdivision.CurrentNetWorth : null,
    AccountDetailed: subdivision ? subdivision.AccountDetailed : null,
    NetWorth: subdivision ? subdivision.NetWorth : null,
    NetTotalInRed: subdivision ? subdivision.NetTotalInRed : false,
    page: subdivision ? subdivision.page : null,
    start_title: subdivision ? subdivision.start_title : null,
    range: subdivision
      ? subdivision.range
        ? subdivision.range
        : subdivision.start_title
      : 'Last 30 Days',
    hasAccessToLinkAccounts: hasAccessToLinkAccountsSelector(state),
    showNetWorth: showNetWorthSelector(state),
    portalName: selectPortalName(state),
    historyOptions: subdivision
      ? subdivision.NetWorth.History.map(({ Title, IsDefault }) => ({
          value: Title,
          label: Title,
          isDefault: IsDefault,
        }))
      : [],
  };
};

const mapDispatchToProps = dispatch => ({
  fetchData(is_recommended, owners, clientId) {
    dispatch(actions.fetch_data(is_recommended, owners, clientId));
  },
  setRange(range, clientId) {
    dispatch(actions.set_range(range, clientId));
  },
  unset_errors(clientId) {
    function return_function1() {
      dispatch(actions.set_errors('', this.clientId));
    }
    return return_function1.bind({ clientId });
  },
  resetState() {
    dispatch(actions.resetState());
  },
});

const NetWorthReport = connect(mapStateToProps, mapDispatchToProps)(ProjectedBalanceSheetView);

export default NetWorthReport;
